import React from 'react'
import { Typography, Box, Button, Container } from "@mui/material"
import businneses from '../Assets/businneses.jpg'
import research from '../Assets/research.jpg'
import learning from '../Assets/learning.jpg'

const Home = () => {

    const scrollToSection = (sectionId) => {
        const section = document.getElementById(sectionId)
        if (section) {
            section.scrollIntoView({behavior: 'smooth'})
        }
    }

  return (
    <Box id = 'home' sx={{width: '100%', paddingTop: '6rem', paddingBottom: '2rem'}}>

       <Typography sx={{fontSize: '1.1rem', textAlign: 'left', marginTop: '1rem', marginBottom: '1rem', marginLeft:'6rem', marginRight: '6rem',
                                '@media (max-with: 442px)': {fontSize: '1rem'}}}> 
                              Data harnessing is a sustainable process that captures and converts data into actionable insight. Actionable insight which is then used to make informed business decisions. Data harnessing turns raw information and data into an asset that helps businesses improve their products and services. They then increase their bottom line. Proantra is here to support you in your data harnessing journey. 

                             
       </Typography>


       <Typography sx={{fontSize: '1.1rem', textAlign: 'left', marginBottom: '1rem',  marginLeft:'6rem', marginRight: '6rem',
                        '@media (max-with: 442px)': {fontSize: '1rem'}}}>
            <strong> Here is how to get started:</strong>  
       </Typography>

       <Typography sx={{fontSize: '1.1rem', textAlign: 'left', marginTop: '1rem', marginLeft:'6rem', marginRight: '6rem',
                        '@media (max-with: 442px)': {fontSize: '1rem'}}}>
            
            - Check out some of our featured products
       </Typography>

       <Typography sx={{fontSize: '1.1rem', textAlign: 'left',  marginLeft:'6rem', marginRight: '6rem',
                        '@media (max-with: 442px)': {fontSize: '1rem'}}}>
            
            - Contact us for value assessment. Learn more about Proantra and where possible, we briefly discuss your project and go ahead and build a simple prototype solution, at no cost to you!


       </Typography>

       <Typography sx={{fontSize: '1.1rem', textAlign: 'left', marginBottom: '1rem',  marginLeft:'6rem', marginRight: '6rem',
                        '@media (max-with: 442px)': {fontSize: '1rem'}}}>
            - Discuss next steps based on what comes out of the value assessment

       </Typography>


       <Typography sx={{fontSize: '1.1rem', textAlign: 'left', marginBottom: '1rem', fontWeight: 'bold', marginLeft:'6rem', marginRight: '6rem'}}>
       Our clients and partners:
       </Typography>

       <Typography sx={{fontSize: '1.1rem', textAlign: 'left', marginTop: '1rem', marginBottom: '1rem', marginLeft:'6rem', marginRight: '6rem',
                                '@media (max-with: 442px)': {fontSize: '1rem'}}}> 
            All entities who want to gain insight into their data in a sustainable manner, are our potential clients. Our clients become our partners in business. Our intention is to develop partnerships that work together towards the common goal of success!

       </Typography>

       <Box sx={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', 
                 width: '100%', textAlign: 'center', gap: '6rem', marginBottom: '2rem'}}>

          <Box sx={{textAlign: 'left'}}>
            <img src={businneses} alt='Businneses-1' style = {{width: '20rem', height: '12rem', borderRadius: '0.5rem'}}/>
            <Typography sx={{fontSize: '1.1rem', width: '15rem', textAlign: 'left', fontWeight: 'bold'}}> Industries/ Businesses: </Typography>
                <Typography sx={{width: '20rem', textAlign: 'left'}}>
                Supply Chain, Manufacturing, Healthcare and other Business Operations.
                </Typography> 
 
          </Box> 

          <Box sx={{textAlign: 'left'}}>
            <img src={research} alt='Research-2' style = {{width: '20rem', height: '12rem', borderRadius: '0.5rem'}}/>
            <Typography sx={{fontSize: '1.1rem', width: '15rem', textAlign: 'left', fontWeight: 'bold'}}> Research Entities: </Typography>
                <Typography sx={{width: '20rem', textAlign: 'left'}}>
                Support research with Data Science e.g building Machine Learning models.
                </Typography> 
 
          </Box>  

          <Box sx={{textAlign: 'left'}}>
            <img src={learning} alt='Learning-3' style = {{width: '20rem', height: '12rem', borderRadius: '0.5rem'}}/>
            <Typography sx={{fontSize: '1.1rem', width: '15rem', textAlign: 'left', fontWeight: 'bold'}}> Learning Institutions: </Typography>
                <Typography sx={{width: '20rem', textAlign: 'left'}}>
                Collaborate on research and teaching. Giving back to the community.
                </Typography> 
 
          </Box>  

       </Box>

         <Container sx={{textAlign: 'center', width: '20rem', marginBottom: '1rem'}}>
            <Typography sx={{fontSize: '1.1rem', fontWeight : 'bold'}}> Contact us with inquiries: </Typography>
            <Button sx={{backgroundColor: '#064760', color: 'white', transition:'transform 0.3s', marginTop: '1rem',
                                   '&:hover':{transform: 'scale(1.025)', backgroundImage: 'linear-gradient(to bottom, #064760, #000000)'}}}
                                   onClick={()=> scrollToSection('contact')}> 
                         Contact Us 
            </Button>    
        </Container> 

    </Box>
  )
}

export default Home